// axios.js

import axios from "axios";
import router from "../router"; // 假设你的路由配置在router.js中

const authToken = 'e301e4b8-2edf-4c77-85cf-b88b6c3ba037';  // 请将yourAuthToken替换为实际的认证令牌


const instance = axios.create({
  baseURL: "https://back.dxnyyun.com/daxing/wechat/api",
  //baseURL: "http://192.168.3.24:8082/daxing/wechat/api",
  timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "AUTH-TOKEN":authToken
  },
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    if (config.method == "post") {
      config.headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        "AUTH-TOKEN":authToken
      };
    }

// // 设置 auth-token
//     if (authToken) {
//       config.headers['AUTH-TOKEN'] = authToken;
//     }

    // console.log("config", config);

    let userInfos = localStorage.getItem("user_info");
    // 将获取到的JSON字符串转换回对象
    let userInfo = JSON.parse(userInfos);
    // sessionStorage.setItem("user_info",userInfo);
    // console.log("userInfo", userInfo);
    if (config.url != "/user/login") {
      if (userInfo == undefined || userInfo == null) {
        router.replace("/loginPage");
        window.location.href =
          "https://web.dxnyyun.com/large_screen/#/loginPage?state=1";
      } else {
        axios
          .get(
            "https://back.dxnyyun.com/daxing/wechat/api/user/listsKey?username=" +
              userInfo.loginName,{
                headers: {
                  "AUTH-TOKEN":authToken,
                  'Content-Type': 'application/json'
                }
              }
          )
          .then((res) => {
            // console.log("登录状态-res===", res.data.data);
            let data = res.data.data;
            if (data.online == "C" && data.key == userInfo.key) {
              // console.log("登录状态-正常");
            } else {
              // console.log("登录状态-过期");
              router.replace("/loginPage");
              window.location.href =
                "https://web.dxnyyun.com/large_screen/#/loginPage?state=1";
            }
          })
          .catch((error) => {
            console.log("登录状态-error===", error);
          });
      }
    }

    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 对响应数据做点什么
    return response.data;
  },
  function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

export default instance;
